import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
Vue.use(VueRouter)

const router = new VueRouter({
    base: '/series/',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})
router.beforeEach((to, from, next) => {
  next()
  // if (IsPC()) {
  //   //pc端跳转并传参
  //   let arr = []
  //   if (undefined != to.query.room && to.query.room != '') {
  //     arr.push(`room=${to.query.room}`)
  //   }
  //   if (undefined != to.query.conventionId && to.query.conventionId != '') {
  //     arr.push(`conventionId=${to.query.conventionId}`)
  //   }
  //   if (arr.length == 0) {
  //     window.location.href = "http://live-pc.yunicu.com/#/live"
  //   } else {
  //     window.location.href = ("http://live-pc.yunicu.com/#/live?" + arr.join('&'))
  //   }
  // } else {
  //   next()
  // }
})

function IsPC() {
  var userAgentInfo = navigator.userAgent.toLowerCase();
  var userAgent = navigator.userAgent;
  
  if (userAgentInfo.indexOf('miniprogram') > -1 || userAgentInfo.indexOf('mini_program') > -1 || window.__wxjs_environment === 'miniprogram') {
    return false;
  }
  
  if (userAgentInfo.indexOf('micromessenger') > -1) {
    if (userAgent.indexOf('Windows') > -1 || userAgent.indexOf('Win32') > -1) {
      return true;
    }
    return false;
  }
  
  var Agents = ["Android", "iPhone",
      "SymbianOS", "Windows Phone",
      "iPad", "iPod", "harmonyos", "openharmony"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > -1) {
      flag = false;
      break;
    }
  }
  return flag;
}

export default router
